import { Flex, Icon, Text } from '@podiumhq/design-system';
import PaymentRequest from '../../components/PaymentRequest';

export const businessContent = (
  <Text color="black.base" fontSize="sm">
    Hi Sarah- Thanks for your furniture order! Your total is $1,500.00
  </Text>
);

export const requestContent = 'Payment request of $1,500.';

export const requestIcon = (
  <Flex
    bg="black.base"
    w="24px"
    h="24px"
    alignItems="center"
    justifyContent="center"
    borderRadius="4px"
    mr="8px"
  >
    <Icon type="Payments" boxSize={5} />
  </Flex>
);

export const customerTextContent = <PaymentRequest amount="1,500.00" />;

export const testimonialText =
  '“Van Horn Auto Group collected $10M+ with Podium Payments and has a 92% collection rate.”';

export const testimonialAttribution = 'Tina Tasche | Van Horn Auto Group';
